import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';
import JobProfileDisplay from './JobProfileDisplay';
import JobProfileEdit from './JobProfileEdit';
import { growlActionSuccess, growlErrors } from '../../../utils/NotificationUtil';
import { NotificationContext } from '../../../components/GrowlNotifications';
import { updateJobProfile } from '../../../services/apps/JobProfileService';
import { AccountContext } from '../../../components/AccountContext';

const messages = defineMessages({
  successNoti: {
    id: 'noti.success',
    defaultMessage: 'Success!',
  },
});

const JobProfileDetailCore = ({ jobProfile }) => {
  const [editMode, setEditMode] = useState(false);

  const { formatMessage } = useIntl();
  const currentAccount = useContext(AccountContext);
  const growl = useContext(NotificationContext);

  const toggleEdit = () => {
    setEditMode((previousState) => !previousState);
  };

  const handleSubmitEdit = async (formValues) => {
    handleJobProfileEdit({ ...formValues });
    toggleEdit();
  };

  const handleJobProfileEdit = async (input) => {
    try {
      await updateJobProfile({
        ...input,
        jobProfileId: jobProfile.id,
        accountId: currentAccount,
      });
      growlActionSuccess(growl, formatMessage(messages.successNoti));
    } catch (errors) {
      growlErrors(growl, errors);
    }
  };

  if (editMode) {
    return <JobProfileEdit jobProfile={jobProfile} toggleEdit={toggleEdit} onEdit={handleSubmitEdit} />;
  }

  return <JobProfileDisplay jobProfile={jobProfile} toggleEdit={toggleEdit} />;
};

JobProfileDetailCore.propTypes = {
  jobProfile: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default JobProfileDetailCore;
